import { useReducer } from "react";
import constate from "constate";
import { ApplicationState } from "./ApplicationState";
import { ApplicationAction, UPDATE } from "./ApplicationActions";
import { Warehouse } from "../models/Warehouse";
import { Product, ProductCategory } from "../models/Product";

// Initial state
const initialState: ApplicationState = {
  selectedWarehouse: undefined,
  selectedDateFrom: undefined,
  selectedDateTo: undefined,
  selectedProductCategory: undefined,
  selectedProduct: undefined,
  serialPort: undefined,
  serialPortValue: "",
  mainMenu: [],
  businessYear: new Date().getFullYear(),
};

let applicationState = initialState;

// Reducer
const reducer = (
  state: ApplicationState,
  action: ApplicationAction
): ApplicationState => {
  let newState = state;
  switch (action.type) {
    case UPDATE:
      newState = { ...state, ...action.payload };
  }
  applicationState = newState;
  return newState;
};

// Custom hook with state and functions
const useApplicationContextSpec = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const selectedWarehouseSet = (selectedWarehouse: Warehouse | undefined) => {
    dispatch({
      type: UPDATE,
      payload: {
        selectedWarehouse,
      },
    });
  };

  const selectedDateFromSet = (selectedDateFrom: Date | undefined) => {
    dispatch({
      type: UPDATE,
      payload: {
        selectedDateFrom,
      },
    });
  };

  const selectedDateToSet = (selectedDateTo: Date | undefined) => {
    dispatch({
      type: UPDATE,
      payload: {
        selectedDateTo,
      },
    });
  };

  const selectedProductCategorySet = (
    selectedProductCategory: ProductCategory | undefined
  ) => {
    dispatch({
      type: UPDATE,
      payload: {
        selectedProductCategory,
      },
    });
  };

  const selectedProductSet = (selectedProduct: Product | undefined) => {
    dispatch({
      type: UPDATE,
      payload: {
        selectedProduct,
      },
    });
  };

  const serialPortSet = (serialPort: SerialPort | undefined) => {
    dispatch({
      type: UPDATE,
      payload: {
        serialPort,
      },
    });
  };

  const serialPortValueSet = (serialPortValue: string) => {
    dispatch({
      type: UPDATE,
      payload: {
        serialPortValue,
      },
    });
  };

  const setMainMenu = (menu: any[]) => {
    dispatch({
      type: UPDATE,
      payload: {
        mainMenu: menu,
      },
    });
  };

  const selectedReqDateFromSet = (selectedReqDateFrom: Date | undefined) => {
    dispatch({
      type: UPDATE,
      payload: {
        selectedReqDateFrom,
      },
    });
  };

  const selectedReqDateToSet = (selectedReqDateTo: Date | undefined) => {
    dispatch({
      type: UPDATE,
      payload: {
        selectedReqDateTo,
      },
    });
  };

  const selectedReqProductCategorySet = (
    selectedReqProductCategory: ProductCategory | undefined
  ) => {
    dispatch({
      type: UPDATE,
      payload: {
        selectedReqProductCategory,
      },
    });
  };

  const selectedReqProductSet = (selectedReqProduct: Product | undefined) => {
    dispatch({
      type: UPDATE,
      payload: {
        selectedReqProduct,
      },
    });
  };

  const businessYearSet = (businessYear: number | undefined) => {
    dispatch({
      type: UPDATE,
      payload: {
        businessYear,
      },
    });
  };

  return {
    state,
    selectedWarehouseSet,
    selectedDateFromSet,
    selectedDateToSet,
    selectedProductCategorySet,
    selectedProductSet,
    serialPortSet,
    serialPortValueSet,
    setMainMenu,
    selectedReqDateFromSet,
    selectedReqDateToSet,
    selectedReqProductCategorySet,
    selectedReqProductSet,
    businessYearSet,
  };
};

export const getApplicationState = () => applicationState;

// Share your custom hook
export const [ApplicationProvider, useApplicationContext] = constate(
  useApplicationContextSpec
);
